import { render, staticRenderFns } from "./TermsDetail.vue?vue&type=template&id=5fd1e9f3&scoped=true&"
import script from "./TermsDetail.vue?vue&type=script&lang=js&"
export * from "./TermsDetail.vue?vue&type=script&lang=js&"
import style0 from "./TermsDetail.vue?vue&type=style&index=0&id=5fd1e9f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd1e9f3",
  null
  
)

export default component.exports